import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dd5d376"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "on-drop"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"dragText\" data-v-3dd5d376><span class=\"dragDrop\" data-v-3dd5d376>Drag and Drop or </span><label for=\"file-input\" data-v-3dd5d376>CHOOSE FILE</label> to upload </div><div class=\"drag-subtext\" data-v-3dd5d376> Document types allowed for upload are &quot;jpeg, jpg, png, bmp, tiff, tif, pdf&quot; </div><div class=\"cloud-folder\" data-v-3dd5d376></div>", 3)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["file-upload dragDropContainer", { 'on-drag': _ctx.isDragging }]),
    onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
    onDragenter: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
    onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)))
  }, [
    (_ctx.isDragging)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "DROP HERE"))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createElementVNode("input", {
      type: "file",
      id: "file-input",
      style: {"display":"none"},
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileChange && _ctx.handleFileChange(...args))),
      multiple: ""
    }, null, 32)
  ], 34))
}